var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-danger",on:{"click":function($event){return _vm.mostrarJustificativa()}}},[_c('i',{staticClass:"fa fa-asterisk icon-button",attrs:{"title":`Data de previsão reprogramada: ${_vm.entrega.justificativaDataPrevisaoReprogramada}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }